import { useMemo } from 'react';
import { AutoMode } from '@mui/icons-material';
import { Badge, Box, Tooltip } from '@mui/material';
import { useAsyncProcessor } from '../../../context/AsyncProcessorContext/AsyncProcessorContext';

const AsyncJobProcessingIndicator = () => {
  const { processingJobs } = useAsyncProcessor();

  const tooltipTitle = useMemo(
    () =>
      processingJobs.length ? processingJobs.map(item => `${item.details.title}: ${item.details.description}`) : '',
    [processingJobs]
  );

  if (!processingJobs.length) return null;

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', marginLeft: '1rem' }}
      className="sidebar-bottom__menu-icon">
      <Badge badgeContent={processingJobs.length} color="primary">
        <Tooltip title={tooltipTitle} placement="right">
          <AutoMode sx={{ color: 'white' }} />
        </Tooltip>
      </Badge>
    </Box>
  );
};

export default AsyncJobProcessingIndicator;
